import { render, staticRenderFns } from "./ReservaDetail.vue?vue&type=template&id=b4383426&scoped=true"
import script from "./ReservaDetail.vue?vue&type=script&lang=js"
export * from "./ReservaDetail.vue?vue&type=script&lang=js"
import style0 from "./ReservaDetail.vue?vue&type=style&index=0&id=b4383426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4383426",
  null
  
)

export default component.exports